import React from 'react';
import {SortableHandle} from 'react-sortable-hoc';

// react-sortable-hoc leaves the mousedown on a handle alone, so the browser starts a text selection there that grows
// across the page for the whole drag. Cancelling the mousedown stops the selection without affecting the sort, but it
// also stops the browser moving focus, so blur the focused input ourselves: some, like option values in the form
// builder, only save on blur.
function preventTextSelection(event) {
  event.preventDefault();
  if (document.activeElement && document.activeElement !== document.body) {
    document.activeElement.blur();
  }
}

export default function dragHandle(Component) {
  return SortableHandle(props => <Component onMouseDown={preventTextSelection} {...props} />);
}
